

const toggleAbout = (event) => {
  const root = document.getElementById('root');
  if (root.classList.contains('about')) {
    root.classList.remove('about');
  } else {
    root.classList.add('about');
  }
}

document.getElementById('logo').addEventListener("click", toggleAbout);
